<template>
  <div class="lego-drop-holder lego-input" :class="dropdownClass" ref="legoDropHolder">
    <div
      class="lego-drop-holder__holder"
      v-dropdown-click-outside="toggleItemOuter"
      @click="toggleItem"
    >
      <slot />
      <lego-icon
        v-if="dropdownIcon"
        class="lego-dropdown__icon"
        icon="expand_menu"
        size="10px"
        :style="caretStyle"
      />
    </div>
    <lego-dropdown-menu
      :items="items"
      :isItemShowing="isItemShowing"
      :width="itemWidth"
      :itemMaxHeight="itemMaxHeight"
      :appendToBody="appendToBody"
      :targetInterval="targetInterval"
      :menuDirection="menuDirection"
      :shadow="menuShadow"
      :customButtonText="customButtonText"
      :itemValue="itemValue"
      :itemText="itemText"
      :noDataText="noDataText"
      :groups="groups"
      parent="legoDropHolder"
      @click="clickItem"
      @close="toggleItemOuter"
      @customButtonClick="customButtonClick"
    >
      <template #menuHeader>
        <slot name="dropHolderMenuHeader"></slot>
      </template>
    </lego-dropdown-menu>
  </div>
</template>

<script>
import legoDropdownMenu from './legoDropdownMenu';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';

export default {
  emits: ['open', 'click', 'customButtonClick'],
  components: { legoDropdownMenu },
  props: {
    appendToBody: { type: Boolean, default: false },
    targetInterval: { type: Number, default: 0 },
    menuDirection: { type: String, default: 'left' },
    itemWidth: { type: [Number, String], default: 150 },
    menuShadow: {
      type: Boolean,
      default: false
    },
    itemMaxHeight: {
      type: [Number, String],
      default: 272
    },
    customButtonText: {
      type: String,
      default: ''
    },
    noDataText: {
      type: String,
      default: ''
    },
    groups: {
      type: Array,
      default: () => []
    },
    dropdownIcon: { type: Boolean, default: false },
    tableIdx: {
      type: Number
    }
  },
  mounted() {
    legoEventBus.$on('click-outside', this.toggleItemOuter);
  },
  beforeUnmount() {
    legoEventBus.$off('click-outside', this.toggleItemOuter);
  },
  watch: {
    isItemShowing() {
      this.$emit('open', this.isItemShowing);
    }
  },
  computed: {
    caretStyle() {
      let style = {};
      if (this.isItemShowing) {
        style['transform'] = 'rotate(-180deg)';
      }
      style['transition-duration'] = '0.3s';
      return style;
    }
  },
  methods: {
    clickItem(item) {
      this.$emit('click', { ...item, tableIdx: this.tableIdx });
      this.toggleItem();
    },
    customButtonClick(button) {
      this.$emit('customButtonClick', button);
    }
  }
};
</script>
<style scoped lang="scss">
:deep .lego-dropdown-menu {
  border-radius: 2px;
}
</style>
